import { render, staticRenderFns } from "./Pagos2Banner.vue?vue&type=template&id=e69de234&scoped=true"
import script from "./Pagos2Banner.vue?vue&type=script&lang=js"
export * from "./Pagos2Banner.vue?vue&type=script&lang=js"
import style0 from "./Pagos2Banner.vue?vue&type=style&index=0&id=e69de234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e69de234",
  null
  
)

export default component.exports